module.exports = __webpack_public_path__ + "img/5_irene_h.b037aac4.png";